import React from 'react'
import img2 from '../components/images/tto/tto_banner.png'
import SavemaTTODealer from './SavemaTTODealer '
function SavemaTTO() {
  return (
    <div>
      <section>
              <div className="w-full h-full relative mt-5 font-poppins">
            <img
              src={img2}
              alt="Banner"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 to-orange-500"></div>
            {/* Optional overlay text */}
          </div>
          
        </section>
        <section>
          <SavemaTTODealer/>
        </section>
    </div>
  )
}

export default SavemaTTO
